import { ColumnProps } from "antd/lib/table";
import HistoryContent from "components/HistoryContent/HistoryContent";
import { formatNumber } from "helpers/number";
import _ from "lodash";
import { AppUser } from "models/AppUser";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LayoutCell, LayoutHeader, OneLineText } from "react3l-ui-library";
import { appUserRepository } from "repositories/app-user-repository";
import { requestHistoryService } from "services/page-services/request-history-service";

export function useAppUserHistoryDetailHook() {
  const { content, oldContent, requestHistories, getRowContent, getContents } =
    requestHistoryService.useHistoryRequestDetail(
      appUserRepository.compareRequestHistory
    );

  const [translate] = useTranslation();

  const history = useHistory();
  const handleGoBack = React.useCallback(() => {
    history.goBack();
  }, [history]);

  const appUserRolesInit: AppUser[] = getContents<AppUser>("appUserRoles");
  // const [arrHistory, setArrHistory] = React.useState([]);
  const [isFirstLoad, setIsFirstLoad] = React.useState<boolean>(false);
  const [arrHistory, setArrHistory] = React.useState([]);
  const [checkPath, setCheckPath] = React.useState<boolean>(false);

  const appUserRoles = React.useMemo(() => {
    // const newArray: any[] = [];
    // const groupData = _.groupBy(appUserRolesInit, (x) => x?.parentId);
    // for (const [key, value] of Object.entries(groupData)) {
    //   if (Number(key)) {
    //     value.forEach((itemChildren) => {
    //       newArray.push({
    //         ...itemChildren,
    //         index:
    //           itemChildren?.parentId + "-" + itemChildren?.appUserResource?.id,
    //       });
    //     });
    //   }
    //   if (!Number(key)) {
    //     value.forEach((itemParent) => {
    //       newArray.push({
    //         ...itemParent,
    //         index: itemParent?.roleId + "-" + itemParent?.appUserResource?.id,
    //       });
    //     });
    //   }
    // }
    // return _.sortBy(newArray, "index");
    return _.sortBy(appUserRolesInit, ["id", "appUserResourceId"]);
  }, [appUserRolesInit]);

  React.useEffect(() => {
    if (window.location.href.includes("different")) {
      setCheckPath(true);
    }
  }, [])

  React.useEffect(() => {
    if (content?.appUserRoles?.length > 0 && oldContent?.appUserRoles?.length > 0 && appUserRolesInit?.length > 0
      && window.location.href.includes("different")) {
      if (!isFirstLoad) {
        setIsFirstLoad(true);
        const arrHistoryHere = [];
        const contentHere = content?.appUserRoles;
        const oldContentHere = oldContent?.appUserRoles;
        //Trường hợp sửa
        for (let i = 0; i < contentHere?.length; i++) {
          for (let z = 0; z < appUserRolesInit?.length; z++) {
            if (contentHere[i]?.rowId === appUserRolesInit[z]?.rowId) {
              if (contentHere[i]?.appUserResource?.fieldEntityId !== appUserRolesInit[z]?.appUserResource?.fieldEntityId
                || contentHere[i]?.appUserResource?.masterDatas?.map((item: any) => item.id)?.toString()
                !== appUserRolesInit[z]?.appUserResource?.masterDatas?.map((item: any) => item.id)?.toString()) {
                arrHistoryHere.push(appUserRolesInit[z]);
              }
            }
          }
        }
        //Trường hợp xóa
        const diffArrayContent = _.differenceBy(appUserRolesInit, contentHere, 'rowId');
        for (let i = 0; i < diffArrayContent?.length; i++) {
          arrHistoryHere.push(diffArrayContent[i])
        }
        //Trường hợp thêm mới
        const diffArrayOldContent = _.differenceBy(appUserRolesInit, oldContentHere, 'rowId');
        for (let i = 0; i < diffArrayOldContent?.length; i++) {
          arrHistoryHere.push(diffArrayOldContent[i])
        }
        setArrHistory(_.sortBy(arrHistoryHere, ["id", "appUserResourceId"]));
      }
    }
  }, [content?.appUserRoles, oldContent?.appUserRoles, appUserRolesInit, isFirstLoad])


  const columns: ColumnProps<AppUser>[] = React.useMemo(
    () => [
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("general.columns.index")}
          />
        ),
        width: 70,
        ellipsis: true,
        key: "stt",
        dataIndex: "stt",
        render(...params: [number, AppUser, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText
                value={formatNumber(params[2] + 1)}
                countCharacters={1000}
              />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.code")}
          />
        ),
        key: "roleCode",
        dataIndex: "role",
        ellipsis: true,
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content}
              oldContent={oldContent}
              fieldName="role"
              renderContent={content?.role ? content?.role?.code : undefined}
              renderOldContent={
                oldContent?.role ? oldContent?.role?.code : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.name")}
          />
        ),
        key: "roleName",
        dataIndex: "role",
        ellipsis: true,
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content}
              oldContent={oldContent}
              fieldName="role"
              renderContent={content?.role ? content?.role?.name : undefined}
              renderOldContent={
                oldContent?.role ? oldContent?.role?.name : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.type")}
          />
        ),
        key: "assignmentType",
        dataIndex: "assignmentType",
        ellipsis: true,
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content}
              oldContent={oldContent}
              fieldName="assignmentType"
              renderContent={
                content?.assignmentType
                  ? content?.assignmentType?.name
                  : undefined
              }
              renderOldContent={
                oldContent?.assignmentType
                  ? oldContent?.assignmentType?.name
                  : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.subSystem")}
          />
        ),
        key: "roleSubSystem",
        dataIndex: "role",
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            // <LayoutCell orderType="left" tableSize="sm">
            //     <OneLineText value={params[0]?.site?.name} />
            // </LayoutCell>
            <HistoryContent
              content={content}
              oldContent={oldContent}
              fieldName="role"
              renderContent={
                content?.role ? content?.role?.site?.name : undefined
              }
              renderOldContent={
                oldContent?.role ? oldContent?.role?.site?.name : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.condition")}
          />
        ),
        key: "appUserResource",
        dataIndex: "appUserResource",
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content?.appUserResource}
              oldContent={oldContent?.appUserResource}
              fieldName="fieldEntity"
              renderContent={
                content?.appUserResource?.fieldEntity
                  ? content?.appUserResource?.fieldEntity?.name
                  : undefined
              }
              renderOldContent={
                oldContent?.appUserResource?.fieldEntity
                  ? oldContent?.appUserResource?.fieldEntity.name
                  : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.operationCode")}
          />
        ),
        key: "appUserResourceOperationCode",
        dataIndex: "appUserResource",
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content?.appUserResource}
              oldContent={oldContent?.appUserResource}
              fieldName="permissionOperator"
              renderContent={
                content?.appUserResource?.permissionOperator
                  ? content?.appUserResource?.permissionOperator?.name
                  : undefined
              }
              renderOldContent={
                oldContent?.appUserResource?.permissionOperator
                  ? oldContent?.appUserResource?.permissionOperator?.name
                  : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.value")}
          />
        ),
        key: "appUserResourceValue",
        dataIndex: "appUserResource",
        render(...params: [any, AppUser, number]) {
          const { content, oldContent, state } = getRowContent(
            "appUserRoles",
            params[2]
          )(params[1]?.rowId);
          return (
            <HistoryContent
              content={content?.appUserResource}
              oldContent={oldContent?.appUserResource}
              fieldName="masterDatas"
              renderContent={
                content?.appUserResource?.masterDatas
                  ? content?.appUserResource?.masterDatas?.map((item: any) => item.name)?.toString()
                  // {model?.appUserRoles[params[2]]?.appUserResource?.masterDatas?.map((item: any) => item.id)}
                  : undefined
              }
              renderOldContent={
                oldContent?.appUserResource?.masterDatas
                  ? oldContent?.appUserResource?.masterDatas?.map((item: any) => item.name)?.toString()
                  : undefined
              }
              type={state}
              className="p-l--sm"
              showTooltip
              index={params[2]}
            />
          );
        },
      },
    ],
    [translate, getRowContent]
  );

  return {
    handleGoBack,
    requestHistories,
    content,
    oldContent,
    columns,
    appUserRoles,
    arrHistory,
    checkPath
  };
}
